export default {
  footerLink: 'Paramètres des cookies',
  consentModal: {
    title: 'Nous utilisons des cookies',
    description: 'Nous utilisons un minimum de cookies pour le fonctionnement du site, ainsi que des cookies optionnels d\'analyse et de publicité — uniquement avec votre consentement.',
    acceptAllBtn: 'Tout accepter',
    acceptNecessaryBtn: 'Tout refuser',
    showPreferencesBtn: 'Gérer les préférences',
  },
  preferencesModal: {
    title: 'Préférences des cookies',
    acceptAllBtn: 'Tout accepter',
    acceptNecessaryBtn: 'Tout refuser',
    savePreferencesBtn: 'Enregistrer les préférences',
    closeIconLabel: 'Fermer',
    sections: [
      {
        title: 'Nécessaires',
        description: 'Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés.',
        linkedCategory: 'necessary',
      },
      {
        title: 'Analyse',
        description: 'Nous aident à comprendre comment le site est utilisé afin de l\'améliorer.',
        linkedCategory: 'analytics',
      },
      {
        title: 'Publicité',
        description: 'Utilisés pour rendre les publicités plus pertinentes. Activés uniquement avec votre consentement.',
        linkedCategory: 'ads',
      },
    ],
  },
}
